import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { AuthSignalService } from './core/services/auth-signal.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet
  ],
  template: `
    <router-outlet></router-outlet>
  `,
  styles: []
})
export class AppComponent implements OnInit {
  private authService = inject(AuthSignalService);
  
  ngOnInit(): void {
    // Verificar estado de autenticación al iniciar la aplicación
    this.authService.checkAuthState$.next();
  }
}